/*
 * ezk-gift-drawer.js
 * ------------------------------------------------------------------
 * RuffRuff 購入特典（Order Bonus）のギフト選択を、カートの中の
 * ボタンから開けるようにする。
 *
 * なぜ必要か：
 *   RuffRuff のウィジェットは「全ページ共通のフローティングボタン」からしか
 *   開けず、カートページ／カートドロワーにブロックとして埋め込めない（公式ヘルプ記載）。
 *   そこでフローティングボタンを画面外に逃がし、自作ボタンから
 *   プログラム的にクリックして同じダイアログを開く。
 *
 * 仕組み（2026-09-11 実機で確認）：
 *   <ruffruff-order-bonus-app>            ← shadowRoot は open なので外から触れる
 *     ├ button.rob-floating-button        ← これをクリックするとダイアログが開く
 *     └ dialog.rob-dialog                 ← showModal() でトップレイヤーに出る
 *                                            ＝ カートドロワーより手前に重なる
 *
 * ★ display:none で隠すとクリックが効かなくなる（実機で確認済み）。
 *   必ず「画面外に逃がす」方式で隠すこと。
 * ★ ボタンを押してからダイアログが開くまで約 0.6 秒かかる（アプリ側の挺動）。
 *
 * ボタンの出し方は2通り：
 *   ・カートドロワー … snippets/ezk-gift-button.liquid を sections/cart-drawer.liquid から render
 *   ・カートページ … このJSが .cart-info の先頭に同じボタンを注入
 *     （sections/main-cart-items.liquid は 94KB あり、手を入れるリスクが高いため）
 *   ★ 見た目を変えるときは、このファイルとスニペットの両方を直すこと。
 *
 * ★ このJSは全ページで読まれる必要がある。layout/theme.liquid で読むこと。
 *   ドロワーのスニペットだけだと、ドロワーが無いページ（/cart など）で
 *   フローティングボタンが出てしまう。
 *
 * ★ 非公式な手段なので、アプリのアップデートでクラス名が変わると壊れる。
 *   壊れてもボタンが消えるだけで、カート機能自体は壊れない。
 */
(function () {
  'use strict';

  if (window.__ezkGiftDrawerInit) return;
  window.__ezkGiftDrawerInit = true;

  var APP_TAG = 'ruffruff-order-bonus-app';
  var FAB_SELECTOR = '.rob-floating-button';
  var BTN_SELECTOR = '.ezk-gift-btn';
  var ENTRY_CLASS = 'ezk-gift-entry';
  var STYLE_ID = 'ezk-hide-rob-fab';

  var TOTALS_SELECTOR = '.main-cart-totals'; // カートページの合計ブロック

  var LABEL = '特典（ノベルティ）を見る';

  // ★ vertical-align: -0.35em は実機で測って出した補正値。
  //   テーマの .btn が display:inline-block を強く持っていて flex が効かないため、
  //   アイコンと文字がベースライン揃えになり、アイコンが 4.5px 高く出ていた。
  var ICON =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" style="vertical-align:-0.35em;">' +
    '<path d="M20 12v9H4v-9M22 7H2v5h20V7ZM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7ZM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z" ' +
    'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // display:none だとクリックが通らないので、画面外に逃がして隠す
  var HIDE_CSS =
    FAB_SELECTOR +
    '{opacity:0!important;pointer-events:none!important;' +
    'position:fixed!important;left:-9999px!important;bottom:0!important;}';

  function shadow() {
    var app = document.querySelector(APP_TAG);
    return app && app.shadowRoot ? app.shadowRoot : null;
  }

  function fab() {
    var root = shadow();
    return root ? root.querySelector(FAB_SELECTOR) : null;
  }

  function hideFloatingButton() {
    var root = shadow();
    if (!root || root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = HIDE_CSS;
    root.appendChild(style);
  }

  // カートページ（ドロワーが無い）には、ここで同じボタンを注入する。
  // ドロワー側は Liquid のスニペットが出すのでここでは何もしない。
  //
  // ★挿入位置：.cart-info の先頭（「送料を調べる」の上）。
  //   .cart-info の中は折りたたみ項目が並んでいて、それぞれが border-bottom を持つ
  //   （クーポン欄は閉じていると高さ１pxで線だけが残る）。途中に入れると
  //   **ボタンの上下両方に区切り線が出る** ので、先頭に置いてこの並びから抜けている。
  function injectCartPageButton() {
    var totals = document.querySelector(TOTALS_SELECTOR);
    if (!totals || !totals.parentNode) return;

    var container = totals.parentNode;
    if (container.querySelector(BTN_SELECTOR)) return;

    var wrap = document.createElement('div');
    wrap.className = ENTRY_CLASS;
    wrap.style.marginBottom = '2.4rem';
    wrap.innerHTML =
      '<button type="button" class="' +
      BTN_SELECTOR.slice(1) +
      ' btn pointer btn-outline text-center" ' +
      'style="width:100%;display:flex;align-items:center;justify-content:center;gap:0.8rem;">' +
      ICON +
      ' <span>' +
      LABEL +
      '</span></button>';

    container.insertBefore(wrap, container.firstElementChild);
  }

  // 有効なキャンペーンが無いときはフローティングボタン自体が生えないので、
  // その場合はラッパーごと隠す（押しても何も起きないボタンを出さない）。
  //
  // ★ ここで触っていいのは display だけ。
  //   以前 margin-bottom を '' に戻す実装にしていたが、それだと
  //   スニペットが style 属性で持っている margin-bottom まで消えてしまい、
  //   ドロワーでボタンと合計がくっついた（2026-09-14）。
  function syncButtons() {
    var available = !!fab();
    var buttons = document.querySelectorAll(BTN_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var target = buttons[i].parentNode;
      if (!target || !target.classList || !target.classList.contains(ENTRY_CLASS)) {
        target = buttons[i];
      }
      target.style.display = available ? '' : 'none';
    }
  }

  function tick() {
    hideFloatingButton();
    injectCartPageButton();
    syncButtons();
  }

  // アプリのマウントは非同期なので、見つかるまで少し粘る
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    tick();
    if (fab() || tries >= 40) clearInterval(timer); // 最大20秒
  }, 500);

  // カートは中身が差し替わる（renderContents）ので、作り直されたら入れ直す
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      tick();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ボタンは作り直されるのでイベント委譲で拾う
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest(BTN_SELECTOR);
    if (!button) return;

    event.preventDefault();

    var floating = fab();
    if (!floating) return;

    floating.dispatchEvent(
      new MouseEvent('click', { bubbles: true, composed: true, cancelable: true })
    );
  });

  tick();
})();
